// src/components/Table/styles.ts

import styled from 'styled-components';

export const TableContainer = styled.div<{ $className?: string }>`
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #EBEAEB;
  width: 100%;
  ${({ $className }) => $className};
`;

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  background: #F5F5F5;
`;

export const HeaderCell = styled.th<{ $width?: string; $align?: 'left' | 'center' | 'right' }>`
  padding: 12px 16px;
  text-align: ${({ $align }) => $align || 'left'};
  font-weight: 600;
  font-size: 12px;
  color: #6b7280;
  letter-spacing: 0.05em;
  width: ${({ $width }) => $width || 'auto'};
  white-space: nowrap;
`;

export const TableBody = styled.tbody``;

export const BodyRow = styled.tr<{ $clickable?: boolean }>`
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s;
  
  &:last-child {
    border-bottom: none;
  }
  
  ${({ $clickable }) => $clickable && `
    cursor: pointer;
    &:hover {
      background-color: #f9fafb;
    }
  `}
`;

export const DataCell = styled.td<{ $align?: 'left' | 'center' | 'right' }>`
  padding: 16px;
  text-align: ${({ $align }) => $align || 'left'};
  font-size: 14px;
  color: #374151;
  vertical-align: middle;
`;

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
`;

export const LoadingState = styled.div`
  padding: 40px;
  text-align: center;
  color: #6b7280;
`;